module.exports = __webpack_public_path__ + "img/detail-update.a4dfdf22.svg";